import { makeRumInstance } from './make-rum-instance';
export { getErrorMessage } from './helpers/get-error-message';
export { getStaticCode } from './helpers/get-static-code';
export { getStatusCode } from './helpers/get-status-code';
export { getApiError } from './helpers/get-api-error';
export { getApiErrorDetails } from './helpers/get-api-error-details';
export { hasStaticCode } from './helpers/has-static-code';
export { hasStatusCode } from './helpers/has-status-code';
export { isApiError } from './helpers/is-api-error';
export { isAxiosError } from './helpers/is-axios-error';
export { isApi4xxResponse } from './helpers/is-api-4xx-response';
export { datadogRumIntegration, jestIntegration, consoleIntegration, emptyIntegration, } from './integrations';
export { vueErrorEmitterPlugin, browserErrorEmitterPlugin } from './emitters';
export { browserEventsRecorder } from './recorders';
export const glovoRum = makeRumInstance();
export { createGlovoError, isNetworkError } from './helpers/create-glovo-error';
export { safeCall } from './helpers/safe-call';
//# sourceMappingURL=index.js.map